const Styles = theme => ({
  formBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  paperforpopup: {
    width: "27.91vw",
    height: "36.42vh"
  },
  paper: {
    display: "flex",
    width: "50vw",
    height: "50vh"
  },
  formtitle: {
    width: "97%",
    fontSize: "20px",
    color: "#006276",
    // fontVariant: 'all-small-caps',
    // marginBottom: "24px",
    fontWeight: "600",
    [theme.breakpoints.down('lg')]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 16,
      fontSize: "14px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "24px",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "16px",
    },
  },
  loginbutton: {
    width: "100%",
    backgroundColor: "#F54040",
    color: "white",
    marginBottom: "15px",
    "&:hover": {
      backgroundColor: "#F54040",
      opacity: 0.75
    }
  },
  spinner: {
    height: "15px",
    width: "15px",
    position: 'absolute',
    right: 0,
    marginRight: theme.spacing(1)
    // marginRight: "7px"
  },
  popupbutton: {
    widht: "45%",
    backgroundColor: "#006276",
    color: "white",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#006276db",
      color: "white",
    }
  },
  popupCancelButton: {
    widht: "45%",
    borderColor: "#F54040",
    color: "#F54040",
    marginRight: 15,
    "&:hover": {
      opacity: 0.75
    }
  },
  errormsg: {
    color: "#FB0707",
    fontSize: 16,
    [theme.breakpoints.down('lg')]: {
      fontSize: 13,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  fgtpasswdlink: {
    fontSize: "16px",
    color: "#666666",
    textDecoration: "none",
    float: "right",
    textAlign: "right",
    paddingTop: 4,
    [theme.breakpoints.down('lg')]: {
      fontSize: 13
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12
    },
  },
  signuplink: {
    fontSize: "16px",
    color: "#006276",
    textDecoration: 'none',
    fontWeight: 600,
    paddingTop: 16,
    [theme.breakpoints.down('lg')]: {
      fontSize: 13
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 8,
      fontSize: 10
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 16,
      fontSize: 18
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 8,
      fontSize: 12
    },
  },
  infomsg: {
    fontSize: 16,
    letterSpacing: "0",
    color: "#666666",
    opacity: 1,
    // width: "97%",
    // maxWidth: 240,
    fontWeight: "500",
    // [theme.breakpoints.down('lg')]: {
    //   width: 240,
    //   // height: 350,
    // },
    // [theme.breakpoints.down('md')]: {
    //   width: 800,
    //   // height: 350,
    // },
    // [theme.breakpoints.down('sm')]: {
    //   height: "50vh",
    //   // width: "55vw",
    // },
  },
  btn: {
    width: "10.4vw",
    height: "4.12vh",
    backgroundColor: "#F54040",
    marginBottom: "15px",
    "&:hover": {
      backgroundColor: "#F54040",
      opacity: 0.75
    }
  },
  greyText: {
    color: "#666666"
  },
  blueButton: {
    backgroundColor: "#006276",
    color: "white",
    width: "100%",
    textTransform: "none",
    fontSize: 20,
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#006276db",
      color: "white",
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 16
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 12
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14
    },
  },
  fieldTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#2A2A2A",
    marginBottom: 4,
    [theme.breakpoints.down('lg')]: {
      fontSize: 13,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
      marginBottom: 2
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  formControl: {
    padding: "20px 0px 8px 0px",
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      padding: "14px 0px 8px 0px",
    },
    [theme.breakpoints.down('md')]: {
      padding: "10px 0px 8px 0px",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "20px 0px 8px 0px",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "10px 0px 8px 0px",
    },
  },
  errorText: {
    color: "#FB0707",
    paddingTop: 4,
    fontSize: 16,
    [theme.breakpoints.down('lg')]: {
      fontSize: 13,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  loginwithotp: {
    fontSize: "16px",
    color: "#666666",
    textDecoration: "none",
    float: "right",
    textAlign: "right",
    paddingTop: 4,
    [theme.breakpoints.down('lg')]: {
      fontSize: "13px",
    },
    [theme.breakpoints.down('md')]: {
      fontSize: "10px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "10px",
    },
  },
  passwordFormControl: {
    paddingBottom: "16px",
    width: '100%'
  },
  captcha: {
    margin: "24px -20px"
  },
  passwordIcon: {
    [theme.breakpoints.down('lg')]: {
      width: "20px",
      height: "20px",
    },
    [theme.breakpoints.down('md')]: {
      width: "18px",
      height: "18px",
    },
    [theme.breakpoints.down('sm')]: {
      width: "20px",
      height: "20px",
    },
    [theme.breakpoints.down('xs')]: {
      width: "16px",
      height: "16px",
    },
  }
});

export default Styles;
